<template>
    <div>
        <v-dialog class="card-height" v-model="visible" max-width="800px" :persistent="true">
            <v-card>
                <v-toolbar color="#f9f9f9">
                    <v-toolbar-title>{{noticeList[typeAig].name}}</v-toolbar-title>
                </v-toolbar>

                <v-card-text>
                    <p v-html="noticeList[typeAig].value"></p>
                </v-card-text>
                <div style="display:flex;justify-content:right">
                    <v-btn color="default" @click="cancel" v-if="typeAig === 0">取消</v-btn>
                    <v-btn color="primary" @click="nextStep">{{ dialogText }}</v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import userConfirm from '@/assets/js/noticeNew'
    export default {
        name: "BeforeNotice",
        props: {
            value: {
                type: Boolean,
                default: true
            }
        },
        data(){
            return {
                typeAig: 0,
                noticeList:[
                    {
                        name: '投保前提条件确认',
                        value: userConfirm
                    },
                    {
                        name: '投保说明',
                        value: "<p>即将进入投保流程，请仔细阅读投保须知，请仔细阅读<span style='color: #dd122a'>投保须知、保险条款、责任免除条款、客户告知书</span>等，为了保障您的权益，您的投保轨迹将被记录并加密保存。</p><br /><p>本产品由美亚财产保险有限公司承保，由易才宏业保险经纪有限公司提供销售和协助理赔等保险服务</p>"
                    },
                ],
                dialogText: "我已清楚了解并同意"
            }
        },
        computed:{
            visible: {
                get() {
                    return this.value
                },
                set(v) {
                    this.$emit("input", v);
                }
            },
        },
        methods: {
            cancel(){
                this.$router.back();
            },
            nextStep(){
                if(this.typeAig === 1){
                    this.visible = false;
                    return this.$emit("visibleBefore");
                }
                this.dialogText = "确认"
                this.typeAig++;
            }
        }
    }
</script>

<style scoped>

</style>